import React from 'react';

const style = require('./PipelineCounts.less');

export class PipelineCounts extends React.Component<any, any> {
	toggleState = (stage, toggleActive, toggleInactive) => {
		const { multiselectEnabled } = this.props;
		if (this.isActive(stage)) {
			if (toggleInactive) {
				toggleInactive();
			}
		} else {
			if (toggleActive) {
				toggleActive();
			}
		}
	};

	isActive = (stage) => {
		const { filters } = this.props;
		if (!filters) {
			return false;
		}
		return Object.keys(stage.filter).every((k) => filters[k] === stage.filter[k]);
	};

	render() {
		const { pipelineCounts, style = {} } = this.props;

		return (
			<div className="pipelineCounts" style={style}>
				{pipelineCounts.map((pipelineCount, idx: number) => {
					const isFirst = idx === 0;
					const isLast = idx === pipelineCounts.length - 1;
					let stepLinerClassName;
					if (isFirst) {
						stepLinerClassName = 'pipelineCounts__stepLiner--first';
					} else if (isLast) {
						stepLinerClassName = 'pipelineCounts__stepLiner--last';
					} else {
						stepLinerClassName = 'pipelineCounts__stepLiner';
					}
					let iconStyle = { ...pipelineCount.iconStyle, marginRight: 8 };
					const isActive = this.isActive(pipelineCount);
					if (isActive) {
						iconStyle.color = 'white';
					}
					return (
						<div
							key={pipelineCount.name}
							onClick={() =>
								this.toggleState(
									pipelineCount,
									pipelineCount.toggleActive,
									pipelineCount.toggleInactive
								)
							}
							className={`pipelineCounts__step ${isActive ? 'active' : ''}`}
						>
							<div className={`${stepLinerClassName} ${isActive ? 'active' : ''}`} />
							<div className="pipelineCounts__name">
								<span className="inline-block-visible-xl">
									{pipelineCount.icon ? (
										<i style={iconStyle} className={`icons8-font ${pipelineCount.icon}`} />
									) : null}
								</span>
								<span>{pipelineCount.displayName}</span>
							</div>
							<div className="pipelineCounts__count">{pipelineCount.count}</div>
						</div>
					);
				})}
			</div>
		);
	}
}
